import { PermissionData } from '@app/store/typings/state/permission';

export const KEY_PERMISSION_BRAND_FETCH = 'KEY_PERMISSION_BRAND_FETCH';
export interface FetchBrandPermission {
  type: typeof KEY_PERMISSION_BRAND_FETCH;
}
export const KEY_PERMISSION_BRAND_SETDATA = 'KEY_PERMISSION_BRAND_SETDATA';
export interface PermissionBrandSetData {
  type: typeof KEY_PERMISSION_BRAND_SETDATA;
  payload: PermissionData[];
}

export const KEY_PERMISSION_BRAND_CLEAR = 'KEY_PERMISSION_BRAND_CLEAR';
export interface PermissionBrandClear {
  type: typeof KEY_PERMISSION_BRAND_CLEAR;
}

export const KEY_PERMISSION_PROJECT_FETCH = 'KEY_PERMISSION_PROJECT_FETCH';
export interface FetchProjectPermission {
  type: typeof KEY_PERMISSION_PROJECT_FETCH;
}
export const KEY_PERMISSION_PROJECT_SETDATA = 'KEY_PERMISSION_PROJECT_SETDATA';
export interface PermissionProjectSetData {
  type: typeof KEY_PERMISSION_PROJECT_SETDATA;
  payload: PermissionData[];
}

export const KEY_PERMISSION_PROJECT_CLEAR = 'KEY_PERMISSION_PROJECT_CLEAR';
export interface PermissionProjectClear {
  type: typeof KEY_PERMISSION_PROJECT_CLEAR;
}

export type PermissionType =
  | FetchBrandPermission
  | PermissionBrandSetData
  | PermissionBrandClear
  | FetchProjectPermission
  | PermissionProjectSetData
  | PermissionProjectClear;
